export const OPEN_VIP_PLAN_DIALOG = "OPEN_VIP_PLAN_DIALOG";
export const CLOSE_VIP_PLAN_DIALOG = "CLOSE_VIP_PLAN_DIALOG";

export const GET_VIP_PLAN = "GET_VIP_PLAN";
export const CREATE_NEW_VIP_PLAN = "CREATE_NEW_VIP_PLAN";
export const EDIT_VIP_PLAN = "EDIT_VIP_PLAN";
export const DELETE_VIP_PLAN = "DELETE_VIP_PLAN";

export const ACTIVE_INACTIVE_VIP_PLAN = "ACTIVE_INACTIVE_VIP_PLAN";

export const SET_CREATE_VIP_PLAN_DONE = "SET_CREATE_VIP_PLAN_DONE";
export const UNSET_CREATE_VIP_PLAN_DONE = "UNSET_CREATE_VIP_PLAN_DONE";

export const SET_UPDATE_VIP_PLAN_DONE = "SET_UPDATE_VIP_PLAN_DONE";
export const UNSET_UPDATE_VIP_PLAN_DONE = "UNSET_UPDATE_VIP_PLAN_DONE";
